import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, take, tap } from 'rxjs/operators';
import { PartnerOfficeEntity } from '../entities/partnerOffice.entity';
import { State } from '../State';
import { PartnerOfficeActionTypes } from '../State/actions/partners.actions';
import { getPartnerOffices } from '../State/selectors/partners.selectors';

@Injectable({
    providedIn: 'root',
})
export class PartnerOfficeResolver implements Resolve<PartnerOfficeEntity[]> {
    constructor(private store: Store<State>) {}

    resolve() {
        const value$ = this.store.select(getPartnerOffices);

        value$
            .pipe(
                filter(value => !value),
                take(1),
                tap(() => {
                    if (localStorage.getItem('token') != null) {
                        this.store.dispatch(PartnerOfficeActionTypes.GetPartnerOffices());
                    }
                }),
            )
            .subscribe();

        return value$.pipe(
            filter(value => !!value),
            take(1),
        );
    }
}
